// Inline style overrides presentation attributes, so normalize both.
export function runningStitchAttributes(attrs, inheritedColor = "#000") {
  const style = Object.fromEntries(String(attrs.style || "").split(";")
    .map(part => { const at = part.indexOf(":"); return [part.slice(0, at).trim().toLowerCase(), part.slice(at + 1).trim()]; })
    .filter(([key, value]) => key && value));
  const usable = value => value && !["none", "inherit", "initial", "unset"].includes(value);
  const stroke = style.stroke || attrs.stroke;
  const fill = style.fill || attrs.fill;
  const color = usable(stroke) ? stroke : usable(fill) ? fill : inheritedColor;
  for (const key of Object.keys(attrs)) {
    if (/^inkstitch:(fill_|satin_)/.test(key) ||
        ["inkstitch:row_spacing_mm", "inkstitch:angle", "inkstitch:expand_mm"].includes(key)) delete attrs[key];
  }
  delete style.fill;
  delete style.stroke;
  delete style["stroke-width"];
  const remaining = Object.entries(style).map(([k,v]) => `${k}:${v}`).join(";");
  if (remaining) attrs.style = remaining; else delete attrs.style;
  attrs.fill = "none";
  attrs.stroke = color;
  attrs["stroke-width"] = "1";
  attrs["inkstitch:stroke_method"] = "running_stitch";
  return color;
}
